import { render, staticRenderFns } from "./ArchivedProjects.vue?vue&type=template&id=bf092bce&"
import script from "./ArchivedProjects.vue?vue&type=script&lang=js&"
export * from "./ArchivedProjects.vue?vue&type=script&lang=js&"
import style0 from "./ArchivedProjects.vue?vue&type=style&index=0&id=bf092bce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports